import React from "react";

export function Radiobutton({checked = false, onClick, disabled}) {

    return (
        <div className="oct_check ">
            <label className="radio-button">
                <input type="radio" 
                        checked={checked}
                        disabled={disabled} 
                        onChange={disabled ? null : () => onClick(!checked)}/>
            </label>
        </div>
    )
}
